const BASE_URL = 'https://app.chatwoot.com'
const WEBSITE_TOKEN = 'vdLWJRjFVNTnVgVq39bMGXjt'
const SCRIPT_ID = 'chatwoot-sdk'

interface ChatwootWidget {
  toggle: (state?: 'open' | 'close') => void
}

interface ChatwootSDK {
  run: (config: { websiteToken: string; baseUrl: string }) => void
}

declare global {
  interface Window {
    $chatwoot?: ChatwootWidget
    chatwootSDK?: ChatwootSDK
    __chatwootInitialized?: boolean
  }
}

export function initChatwoot() {
  if (window.__chatwootInitialized) return
  window.__chatwootInitialized = true

  let shouldOpenWhenReady = false

  window.addEventListener('open-chat', () => {
    if (window.$chatwoot) {
      window.$chatwoot.toggle('open')
    } else {
      shouldOpenWhenReady = true
    }
  })

  window.addEventListener('chatwoot:ready', () => {
    if (shouldOpenWhenReady) {
      window.$chatwoot?.toggle('open')
      shouldOpenWhenReady = false
    }
  })

  if (document.getElementById(SCRIPT_ID)) return

  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.src = `${BASE_URL}/packs/js/sdk.js`
  script.async = true
  script.onload = () => {
    window.chatwootSDK?.run({
      websiteToken: WEBSITE_TOKEN,
      baseUrl: BASE_URL
    })
  }
  script.onerror = () => {
    console.error('Не удалось загрузить виджет поддержки Chatwoot')
  }

  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }
}
